<template>
    <div>
        {{ $t(label) }}
        <v-chip color="success" label size="small">{{ ratingObject.rating }}</v-chip>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class SupplierRating extends Vue {
        @Prop({default: () => 'review_score'}) label
        @Prop() ratingObject
    }

    export default SupplierRating
</script>
